module.exports = __webpack_public_path__ + "static/media/downloadSuccess.f919ab83.svg";